import { WorkspaceRole } from "@/models/workspace/Workspace";

/** Danish labels for workspace access roles (header badge, sharing UI). */
export const getUserRoleLabel = (role: WorkspaceRole) => {
  switch (role) {
    case WorkspaceRole.READ:
      return "Læse adgang";
    case WorkspaceRole.WRITE:
      return "Upload adgang";
    case WorkspaceRole.ADMIN:
      return "Administrator";
    default:
      return "Ejer";
  }
};

/** Shadcn badge variant per workspace role. */
export const getRoleBadgeVariant = (role: WorkspaceRole) => {
  switch (role) {
    case WorkspaceRole.OWNER:
    case WorkspaceRole.ADMIN:
      return "default";
    case WorkspaceRole.WRITE:
      return "secondary";
    case WorkspaceRole.READ:
      return "outline";
  }
};
